<div adaptToolbarContent
     *ngIf="isActivated">
    <adapt-menu [items]="pageMenuItems"
                data-test="teams-actions-button"></adapt-menu>
</div>

<adapt-organisation-explorer [selectedViewOption]="ViewOption.OrganisationMapTeams"
                             [filterTeams]="filterForMyTeams"
                             (loaded)="notifyActivated()"></adapt-organisation-explorer>
